import React, { useCallback } from 'react';
import { DraftModal } from 'apps/web_forms/components/Modals/DraftModal';
import { LocationFailureModal } from 'apps/web_forms/components/Modals/LocationFailureModal';
import { MultiDispatchFailureModal } from 'apps/web_forms/components/Modals/MultiDispatchFailureModal';
import { RangeFailureModal } from 'apps/web_forms/components/Modals/RangeFailureModal';
import { ResourceLoadingModal } from 'apps/web_forms/components/Modals/ResourceLoadingModal';
import { ResourceUpdateConfirmationModal } from 'apps/web_forms/components/Modals/ResourceUpdateConfirmationModal';
import { SubmitFailureModal } from 'apps/web_forms/components/Modals/SubmitFailureModal';
import { resetModal } from 'apps/web_forms/slices/appSlice';
import { ModalTypes } from 'apps/web_forms/utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { selectOpenModal } from 'apps/web_forms/hooks/useGlobalSelector';
import { ReassignDraftModal } from 'apps/web_forms/components/Modals/ReassignDraftModal'
import { ReassignDraftSuccessModal } from 'apps/web_forms/components/Modals/ReassignDraftSuccessModal'
import { CopyDraftModal } from 'apps/web_forms/components/Modals/CopyDraftModal';
import { CopyDraftSuccessModal } from 'apps/web_forms/components/Modals/CopyDraftSuccessModal';
import { DeleteDraftModal } from 'apps/web_forms/components/Modals/DeleteDraftModal';
import { DeleteDraftSuccessModal } from 'apps/web_forms/components/Modals/DeleteDraftSuccessModal';
import { ExitPageModal } from 'apps/web_forms/components/Modals/ExitPageModal';


const ModalTypeMap = {
  [ModalTypes.DRAFT_MODAL]: DraftModal,
  [ModalTypes.LOCATION_FAILURE_MODAL]: LocationFailureModal,
  [ModalTypes.MULTI_DISPATCH_FAIL_MODAL]: MultiDispatchFailureModal,
  [ModalTypes.RANGE_FAILURE_MODAL]: RangeFailureModal,
  [ModalTypes.RESOURCE_LOADING_MODAL]: ResourceLoadingModal,
  [ModalTypes.RESOURCE_UPDATE_CONFIRMATION_MODAL]: ResourceUpdateConfirmationModal,
  [ModalTypes.SUBMIT_FAIL_MODAL]: SubmitFailureModal,
  [ModalTypes.DRAFT_REASSIGNMENT_MODAL]: ReassignDraftModal,
  [ModalTypes.DRAFT_REASSIGNMENT_SUCCESS_MODAL]: ReassignDraftSuccessModal,
  [ModalTypes.COPY_DRAFT_MODAL]: CopyDraftModal,
  [ModalTypes.COPY_DRAFT_SUCCESS_MODAL]: CopyDraftSuccessModal,
  [ModalTypes.DELETE_DRAFT_MODAL]: DeleteDraftModal,
  [ModalTypes.DELETE_SUCCESS_MODAL]: DeleteDraftSuccessModal,
  [ModalTypes.EXIT_PAGE_MODAL]: ExitPageModal,
};

export const ModalWrapper = () => {
  const dispatch = useDispatch();
  const selectedModal = useSelector(selectOpenModal);

  const resetSelectedModal = useCallback(() => {
    dispatch(resetModal());
  }, [dispatch]);

  if (selectedModal?.type) {
    const ModalComponent = ModalTypeMap[selectedModal.type];

    return (
      <ModalComponent
        resetSelectedModal={resetSelectedModal}
        {...selectedModal}
      />
    );
  }

  return null;
};
